export const SelfServicesCardEnum = {
    MyProfile: {
        key: 1,
        value: 'my-profile',
    },
    ApprovalTracking: {
        key: 2,
        value: 'approvals-tracking',
    },
    InternalVacancies: {
        key: 3,
        value: 'jobs',
    },
    JobRequisition: {
        key: 4,
        value: 'job-requisition',
    },
};
  